import React from 'react';
import PropTypes from 'prop-types';
import DownloadArrow from './DownloadArrow';
import { DownloadArrowDirectionEnum } from '../DownloadOverlayConstants';

const DownloadArrows = (props) => {
  const downloadArrows = [];
  for (let i = 0; i < props.numberOfDownloadArrows; i += 1) {
    let active = false;
    if (i === props.activeDownloadArrowIdx) {
      active = true;
    }
    downloadArrows.push(
      <DownloadArrow
        key={i}
        active={active}
        downloadArrowDirection={props.downloadArrowDirection}
      />,
    );
  }

  return (
    <div className={'download-arrows'}>
      {downloadArrows}
    </div>
  );
};

DownloadArrows.propTypes = {
  activeDownloadArrowIdx: PropTypes.number.isRequired,
  downloadArrowDirection: PropTypes.oneOf([
    DownloadArrowDirectionEnum.UP,
    DownloadArrowDirectionEnum.RIGHT,
    DownloadArrowDirectionEnum.DOWN,
    DownloadArrowDirectionEnum.LEFT,
  ]).isRequired,
  numberOfDownloadArrows: PropTypes.number.isRequired,
};


export default DownloadArrows;



// WEBPACK FOOTER //
// ./src-react/download-overlay/components/DownloadArrows.jsx